/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Dustbin = require('./Dustbin'),
    Item = require('./Item'),
    ItemTypes = require('./ItemTypes'),
    $__0=    require('react-dnd'),NativeDragItemTypes=$__0.NativeDragItemTypes;

var Container = React.createClass({displayName: 'Container',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement("div", {style: {minHeight: '14rem'}}, 
          React.createElement(Dustbin, {accepts: [ItemTypes.GLASS]}), 
          React.createElement(Dustbin, {accepts: [ItemTypes.FOOD]}), 
          React.createElement(Dustbin, {accepts: [ItemTypes.PAPER]}), 
          React.createElement(Dustbin, {accepts: [ItemTypes.PAPER, NativeDragItemTypes.FILE]})
        ), 

        React.createElement("div", {style: { minHeight: '2rem'}}, 
          React.createElement(Item, {name: "Glass", type: ItemTypes.GLASS}), 
          React.createElement(Item, {name: "Banana", type: ItemTypes.FOOD}), 
          React.createElement(Item, {name: "Bottle", type: ItemTypes.GLASS}), 
          React.createElement(Item, {name: "Burger", type: ItemTypes.FOOD}), 
          React.createElement(Item, {name: "Paper", type: ItemTypes.PAPER})
        )
      )
    );
  }
});

module.exports = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-interesting/Container.js
 ** module id = 139
 ** module chunks = 0
 **/